import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
            {/* Left Image */}
            <div className="flex-1 w-full">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20MacBook%20displaying%20organized%20spreadsheet%20data%20on%20warm%20walnut%20wooden%20desk%20ceramic%20coffee%20cup%20and%20small%20succulent%20plant%20natural%20light%20from%20large%20window%20creating%20soft%20shadows%20contemporary%20European%20editorial%20photography%20with%20warm%20neutral%20tones%20and%20breathing%20composition&width=900&height=675&seq=article-preview-v3&orientation=landscape"
                  alt="VigorBuy Spreadsheet workspace and buying guide"
                  title="What Is the VigorBuy Spreadsheet - Complete Guide"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                {/* Tag overlay */}
                <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                  <span className="px-3 py-1.5 text-xs font-medium text-foreground-950 bg-background-50/80 backdrop-blur-sm rounded-full whitespace-nowrap">
                    Updated Daily
                  </span>
                  <span className="px-3 py-1.5 text-xs font-medium text-foreground-950 bg-background-50/80 backdrop-blur-sm rounded-full whitespace-nowrap">
                    Price Compared
                  </span>
                  <span className="px-3 py-1.5 text-xs font-medium text-foreground-950 bg-background-50/80 backdrop-blur-sm rounded-full whitespace-nowrap">
                    Safe Picks
                  </span>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                Your Smart Buying Hub
              </h2>
              <div className="flex flex-wrap items-center gap-2 mt-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-1.5 text-xs font-medium text-primary-700 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
                >
                  vigorbuy sheet
                </a>
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="px-3 py-1.5 text-xs font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  Guide
                </Link>
                <span className="px-3 py-1.5 text-xs font-medium text-foreground-500 whitespace-nowrap">
                  Reviews
                </span>
              </div>

              {/* Article Card */}
              <Link
                to="/vigorbuy-spreadsheet-guide"
                className="block mt-6 bg-background-950 rounded-2xl p-6 md:p-8 hover:bg-background-900 transition-colors duration-300 group"
              >
                <span className="inline-block px-2.5 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full whitespace-nowrap">
                  Editor&apos;s Pick
                </span>
                <div className="flex flex-col md:flex-row gap-6 mt-4">
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">
                      What Is the VigorBuy Spreadsheet?
                    </h3>
                    <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                      The VigorBuy Spreadsheet is a curated product database that helps buyers discover trusted products, compare prices, evaluate sellers, and simplify international shopping. Instead of searching manually, users can browse organized categories, quality information, and buying guides in one place.
                    </p>
                    <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-400 group-hover:text-primary-300 transition-colors whitespace-nowrap">
                      Read Full Guide <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                  <div className="hidden md:block w-32 h-32 rounded-xl overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Clean%20product%20spreadsheet%20interface%20with%20organized%20data%20rows%20on%20laptop%20screen%20soft%20natural%20office%20light%20modern%20digital%20workspace%20aesthetic%20warm%20neutral%20background%20editorial%20tech%20photography%20with%20shallow%20depth%20of%20field&width=300&height=300&seq=article-thumb-v3&orientation=squarish"
                      alt="VigorBuy Spreadsheet interface preview"
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Search Filter Bar */}
          <div className="mt-12 bg-background-100 rounded-2xl p-4 md:p-6">
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <select
                className="w-full sm:w-auto px-4 py-3 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-700 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                onChange={(e) => {
                  if (e.target.value) window.open(e.target.value, '_blank', 'noopener,nofollow');
                }}
                defaultValue=""
              >
                <option value="" disabled>Select Category</option>
                <option value="https://kaspreadsheet.com/category-911-Shoes.html">Shoes</option>
                <option value="https://kaspreadsheet.com/search-912/name/Shoes.html">Hoodies / Sweaters</option>
                <option value="https://kaspreadsheet.com/search-913/name/Shoes.html">T-Shirts</option>
                <option value="https://kaspreadsheet.com/search-914/name/Shoes.html">Jackets</option>
                <option value="https://kaspreadsheet.com/search-915/name/Shoes.html">Pants / Shorts</option>
                <option value="https://kaspreadsheet.com/search-916/name/Shoes.html">Headwear</option>
                <option value="https://kaspreadsheet.com/search-917/name/Shoes.html">Sets</option>
                <option value="https://kaspreadsheet.com/search-918/name/Shoes.html">Underwear / Underpants</option>
                <option value="https://kaspreadsheet.com/search-919/name/Shoes.html">Jersey</option>
                <option value="https://kaspreadsheet.com/search-920/name/Shoes.html">Accessories</option>
                <option value="https://kaspreadsheet.com/search-921/name/Shoes.html">Bags</option>
                <option value="https://kaspreadsheet.com/search-922/name/Shoes.html">Belts</option>
                <option value="https://kaspreadsheet.com/search-923/name/Shoes.html">Perfumes</option>
                <option value="https://kaspreadsheet.com/search-924/name/Shoes.html">Other Stuff</option>
              </select>
              <div className="relative flex-1 w-full">
                <input
                  type="text"
                  placeholder="Search products..."
                  className="w-full pl-10 pr-4 py-3 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
              >
                Search
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}